import Cookies from 'js-cookie';
import { getSharedCookieDomain } from './ga4-postponer';

const COOKIE_EXPIRY_TIME = 1 / 48; // 15 minutes from now

export const trySetCookieCheckoutSource = (source: string) => {
    if (!source) return;
    Cookies.set(`ga4_checkout_source`, source, {
        domain: getSharedCookieDomain(),
        expires: COOKIE_EXPIRY_TIME,
    });
};
